"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _RegisterInstance = _interopRequireDefault(require("../KESI2/Services/RegisterInstance"));

var _QD_Kesi_ConnectChannel = require("../KESI2/Services/QD_Kesi_ConnectChannel");

var _AppChannel = require("../KESI2/Services/AppChannel");

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _react = _interopRequireDefault(require("react"));

var _StringHelper = _interopRequireDefault(require("./StringHelper"));

var _AppUtils = require("../utils/AppUtils");

var _DeviceInfoHelper = _interopRequireDefault(require("./DeviceInfoHelper"));

var _AlertHelper = require("./AlertHelper");

var _qdKesiConnectStrings = require("../common/components/Strings/qdKesiConnectStrings");

var _DataStoreComponent2 = _interopRequireDefault(require("../common/components/DataStoreComponent/DataStoreComponent2"));

var _AblyMessagingCommands = require("../common/constants/AblyMessagingCommands");

var _ArrayHelper = require("./ArrayHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var ConnectHelper = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(ConnectHelper, _DataStoreComponent);

  var _super = _createSuper(ConnectHelper);

  function ConnectHelper(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, ConnectHelper);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setIsOnline", function () {
      _this.setState({
        isOnline: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setIsOffline", function () {
      _this.setState({
        isOnline: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setCodeInput", function (e) {
      _this.setState({
        codeInput: e.target.value
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleRequestConnection", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
        var applicationInstanceId, partners;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(message.data.applicationInstanceId && message.data.connectionCode)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 3;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 3:
                applicationInstanceId = _context.sent;

                if (!(applicationInstanceId !== message.data.applicationInstanceId && _this.connectionCode === message.data.connectionCode)) {
                  _context.next = 14;
                  break;
                }

                partners = _this.state.data[_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS] || [];

                if (!(partners.indexOf(message.data.applicationInstanceId) !== -1)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                if (partners.length === 0) _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_AVAILABLE, true);
                partners.push(message.data.applicationInstanceId);

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS, partners);

                _this.removeAlert();

                (0, _AlertHelper.showAlertHtml)((0, _qdKesiConnectStrings.getString)('QDCONNECT_SUCCESSFUL_TEXT'), (0, _qdKesiConnectStrings.getString)('CONNECT_SUCCESSFUL_ACTIVATED'), true, [{
                  label: 'OK',
                  callback: _this.goHome
                }]);
                (0, _AppChannel.sendMessage)(_AblyMessagingCommands.ABLY_COMMANDS.CONFIRM_CONNECTION, {
                  callee: message.data.applicationInstanceId,
                  caller: applicationInstanceId
                }, message.data.applicationInstanceId);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleCancelConnection", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(message) {
        var applicationInstanceId, partners, newPartners;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!message.data.applicationInstanceId) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 3:
                applicationInstanceId = _context2.sent;

                if (applicationInstanceId !== message.data.applicationInstanceId) {
                  partners = _this.state.data[_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS] || [];
                  newPartners = (0, _ArrayHelper.removeElementFromCopy)(partners, message.data.applicationInstanceId);

                  if (partners.length !== newPartners.length) {
                    _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS, newPartners);

                    if (newPartners.length === 0) {
                      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_AVAILABLE, false);
                    }
                  }
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleConfirmConnection", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(message) {
        var applicationInstanceId, partners;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this.confirmationAllowed) {
                  _context3.next = 18;
                  break;
                }

                if (!(message.data.callee && message.data.caller)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 4;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 4:
                applicationInstanceId = _context3.sent;

                if (!(applicationInstanceId !== message.data.caller && message.data.callee === applicationInstanceId)) {
                  _context3.next = 18;
                  break;
                }

                partners = _this.state.data[_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS] || [];

                if (!(partners.indexOf(message.data.caller) !== -1)) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return");

              case 9:
                if (partners.length === 0) _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_AVAILABLE, true);
                partners.push(message.data.caller);

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS, partners);

                clearTimeout(_this.timeoutID);

                _this.removeAlert();

                (0, _AlertHelper.showAlertHtml)((0, _qdKesiConnectStrings.getString)('QDCONNECT_SUCCESSFUL_TEXT'), (0, _qdKesiConnectStrings.getString)('CONNECT_SUCCESSFUL_ACTIVATED'), true, [{
                  label: 'OK',
                  callback: _this.goHome
                }]);
                _this.confirmationAllowed = false;

                _this.setState({
                  error: false
                });

                _this.setState({
                  codeInput: ''
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkCode", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var callback,
          _args4 = arguments;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              callback = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;

              if (_this.state.codeInput) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              _this.confirmationAllowed = true;
              _context4.t0 = _QD_Kesi_ConnectChannel.sendMessage;
              _context4.t1 = _AblyMessagingCommands.ABLY_COMMANDS.REQUEST_CONNECTION;
              _context4.t2 = _this.state.codeInput.toUpperCase();
              _context4.next = 9;
              return _RegisterInstance["default"].getApplicationInstanceId();

            case 9:
              _context4.t3 = _context4.sent;
              _context4.t4 = {
                connectionCode: _context4.t2,
                applicationInstanceId: _context4.t3
              };
              (0, _context4.t0)(_context4.t1, _context4.t4);
              _this.timeoutID = setTimeout(function () {
                _this.setState({
                  error: true
                });

                _this.confirmationAllowed = false;
                if (callback) callback((0, _qdKesiConnectStrings.getString)('CONNECT_INSERT_ERROR'));
              }, 10000);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeConnection", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(applicationInstanceId) {
        var partners, index;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                partners = _this.state.data[_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS];
                index = partners ? partners.indexOf(applicationInstanceId) : -1;

                if (!(index > -1)) {
                  _context5.next = 13;
                  break;
                }

                partners.splice(index, 1);

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS, partners);

                _context5.t0 = _AppChannel.sendMessage;
                _context5.t1 = _AblyMessagingCommands.ABLY_COMMANDS.CANCEL_CONNECTION;
                _context5.next = 9;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 9:
                _context5.t2 = _context5.sent;
                _context5.t3 = {
                  applicationInstanceId: _context5.t2
                };
                _context5.t4 = applicationInstanceId;
                (0, _context5.t0)(_context5.t1, _context5.t3, _context5.t4);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }());
    _this.state = {
      codeInput: '',
      isOnline: true,
      error: false
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(ConnectHelper.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS]);
    _this.connectionCode = _StringHelper["default"].createShortId().toUpperCase();
    return _this;
  } // Todo move to componentdidmount due to react 16.3


  (0, _createClass2["default"])(ConnectHelper, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      (0, _QD_Kesi_ConnectChannel.register)(_QD_Kesi_ConnectChannel.onMessageForConnectChannel, 'ConnectChannel');
      (0, _AppUtils.registerForAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.REQUEST_CONNECTION, this.handleRequestConnection);
      (0, _AppUtils.registerForAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.CONFIRM_CONNECTION, this.handleConfirmConnection);
      (0, _AppUtils.registerForAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.CANCEL_CONNECTION, this.handleCancelConnection); //registerForAblyMessagesWithcommand('confirmCancelConnection', this.handleConfirmCancelConnection)

      if (_DeviceInfoHelper["default"].isOnline()) this.setIsOnline();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _DeviceInfoHelper["default"].addOnlineListener(this.setIsOnline);

      _DeviceInfoHelper["default"].addOfflineListener(this.setIsOffline);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(ConnectHelper.prototype), "componentWillUnmount", this).call(this);

      _DeviceInfoHelper["default"].removeOnlineListener(this.setIsOnline);

      _DeviceInfoHelper["default"].removeOfflineListener(this.setIsOffline);

      (0, _QD_Kesi_ConnectChannel.unregister)(_QD_Kesi_ConnectChannel.onMessageForConnectChannel, 'ConnectChannel');
      (0, _AppUtils.unregisterFromAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.REQUEST_CONNECTION, this.handleRequestConnection);
      (0, _AppUtils.unregisterFromAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.CONFIRM_CONNECTION, this.handleConfirmConnection);
      (0, _AppUtils.unregisterFromAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.CANCEL_CONNECTION, this.handleCancelConnection); //unregisterFromAblyMessagesWithcommand('confirmCancelConnection', this.handleConfirmCancelConnection)
    } //set in subclass if needed

  }, {
    key: "removeAlert",
    value: function removeAlert() {} //set in subclass if needed

  }, {
    key: "goHome",
    value: function goHome() {}
  }]);
  return ConnectHelper;
}(_DataStoreComponent2["default"]);

var _default = ConnectHelper;
exports["default"] = _default;